/* Clothesline theme — cart drawer + nav + team gate */

(function () {
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  // -------- Money format --------
  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2);
    const fmt = window.shopMoneyFormat || "${{amount}}";
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace(".", ","))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(cents / 100));
  }

  // -------- Cart drawer --------
  const drawer = $("#CartDrawer");
  const overlay = $("#CartOverlay");
  const cartCountEls = $$("[data-cart-count]");
  const cartLinesEl = $("#CartLines");
  const cartSubtotalEl = $("#CartSubtotal");
  const cartCheckoutBtn = $("#CartCheckoutBtn");

  function openCart() {
    if (!drawer) return;
    drawer.classList.add("open");
    overlay.classList.add("open");
    document.body.style.overflow = "hidden";
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove("open");
    overlay.classList.remove("open");
    document.body.style.overflow = "";
  }
  if (overlay) overlay.addEventListener("click", closeCart);
  $$('[data-cart-open]').forEach((el) => el.addEventListener("click", (e) => { e.preventDefault(); refreshCart().then(openCart); }));
  $$('[data-cart-close]').forEach((el) => el.addEventListener("click", closeCart));

  async function refreshCart() {
    try {
      const r = await fetch(window.routes.cart_url + ".js", { headers: { "Accept": "application/json" } });
      const cart = await r.json();
      renderCart(cart);
      return cart;
    } catch (e) { console.error(e); }
  }

  function renderCart(cart) {
    cartCountEls.forEach((el) => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? "" : "none";
    });
    if (!cartLinesEl) return;
    if (cart.items.length === 0) {
      cartLinesEl.innerHTML = `
        <div class="cart-empty">
          <div class="t">Bag's looking empty</div>
          <div class="mt-2">Go grab something soft.</div>
        </div>`;
    } else {
      cartLinesEl.innerHTML = cart.items.map((item) => `
        <div class="line" data-key="${item.key}">
          <div class="img">${item.image ? `<img src="${item.image}" alt="${item.title}">` : ""}</div>
          <div class="info">
            <div class="name">${item.product_title}</div>
            ${item.variant_title && item.variant_title !== "Default Title" ? `<div class="opts">${item.variant_title}</div>` : ""}
            <div class="qty">
              <button data-cart-change="${item.key}" data-qty="${item.quantity - 1}" aria-label="Decrease">−</button>
              <span>${item.quantity}</span>
              <button data-cart-change="${item.key}" data-qty="${item.quantity + 1}" aria-label="Increase">+</button>
              <button data-cart-remove="${item.key}" class="ml-3" aria-label="Remove" title="Remove" style="margin-left:8px;color:var(--muted);">✕</button>
            </div>
          </div>
          <div class="price">${formatMoney(item.final_line_price)}</div>
        </div>
      `).join("");
    }
    if (cartSubtotalEl) cartSubtotalEl.textContent = formatMoney(cart.total_price);
    if (cartCheckoutBtn) cartCheckoutBtn.disabled = cart.item_count === 0;

    cartLinesEl.querySelectorAll("[data-cart-change]").forEach((b) =>
      b.addEventListener("click", () => changeQty(b.dataset.cartChange, parseInt(b.dataset.qty, 10)))
    );
    cartLinesEl.querySelectorAll("[data-cart-remove]").forEach((b) =>
      b.addEventListener("click", () => changeQty(b.dataset.cartRemove, 0))
    );
  }

  async function changeQty(key, quantity) {
    try {
      const r = await fetch(window.routes.cart_change_url + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: key, quantity }),
      });
      const cart = await r.json();
      renderCart(cart);
    } catch (e) { console.error(e); }
  }

  // PDP add to bag
  $$('form[data-product-form]').forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const submitBtn = form.querySelector("[type=submit]");
      if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.original = submitBtn.textContent; submitBtn.textContent = "Adding…"; }
      try {
        const formData = new FormData(form);
        const r = await fetch(window.routes.cart_add_url + ".js", {
          method: "POST",
          headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: formData,
        });
        if (!r.ok) {
          const err = await r.json().catch(() => ({}));
          alert(err.description || err.message || "Could not add to bag");
          return;
        }
        await refreshCart();
        openCart();
      } catch (err) {
        console.error(err);
        alert("Network error — please try again");
      } finally {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.original || "Add to bag"; }
      }
    });
  });

  // PDP variant picker
  $$('[data-variant-picker]').forEach((picker) => {
    const variants = JSON.parse(picker.dataset.variants || "[]");
    const optionGroups = $$('[data-option-group]', picker);
    const variantIdInput = $('input[name="id"]', picker.closest("form"));
    const priceEl = $('[data-product-price]', picker.closest("section, body"));
    const submitBtn = $('button[type="submit"]', picker.closest("form"));

    function pickedOptions() {
      return optionGroups.map((g) => {
        const active = g.querySelector(".active");
        return active ? active.dataset.value : null;
      });
    }
    function findVariant() {
      const picked = pickedOptions();
      return variants.find((v) =>
        v.options.every((opt, i) => picked[i] === opt)
      );
    }
    function update() {
      const v = findVariant();
      if (!v) return;
      if (variantIdInput) variantIdInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (submitBtn) {
        submitBtn.disabled = !v.available;
        submitBtn.textContent = v.available ? (submitBtn.dataset.available || "Add to bag") : (submitBtn.dataset.soldout || "Sold out");
      }
    }
    optionGroups.forEach((g) => {
      g.querySelectorAll("button[data-value]").forEach((b) => {
        b.addEventListener("click", (e) => {
          e.preventDefault();
          g.querySelectorAll("button").forEach((x) => x.classList.remove("active"));
          b.classList.add("active");
          update();
        });
      });
    });
    update();
  });

  // PDP image gallery
  $$('[data-gallery]').forEach((gallery) => {
    const main = $('[data-gallery-main]', gallery);
    $$('[data-gallery-thumb]', gallery).forEach((thumb, idx) => {
      thumb.addEventListener("click", () => {
        const src = thumb.dataset.src;
        if (main && src) main.querySelector("img").src = src;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach((t) => t.classList.remove("active"));
        thumb.classList.add("active");
      });
    });
  });

  // Mobile nav toggle
  const mobileToggle = $('[data-mobile-toggle]');
  const mobileNav = $('[data-mobile-nav]');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener("click", () => mobileNav.classList.toggle("open"));
  }

  // Team gate
  const teamForm = $('[data-team-gate-form]');
  if (teamForm) {
    const errEl = $('[data-team-error]', teamForm);
    const pwAttr = teamForm.dataset.teamPassword || "";
    const targetHandle = teamForm.dataset.teamCollection || "team";
    teamForm.addEventListener("submit", (e) => {
      e.preventDefault();
      const entered = teamForm.querySelector('input[name="team_password"]').value;
      if (entered && entered === pwAttr) {
        try { localStorage.setItem("clothesline_team_unlocked", "yes"); } catch (e) {}
        window.location.href = "/collections/" + targetHandle;
      } else {
        if (errEl) errEl.textContent = "Wrong password.";
      }
    });
  }

  // Team collection guard
  const teamGuard = $('[data-team-guard]');
  if (teamGuard) {
    let ok = false;
    try { ok = localStorage.getItem("clothesline_team_unlocked") === "yes"; } catch (e) {}
    if (!ok) {
      window.location.replace("/pages/team");
    } else {
      teamGuard.style.display = "";
      const lockBtn = $('[data-team-lock]');
      if (lockBtn) lockBtn.addEventListener("click", () => {
        try { localStorage.removeItem("clothesline_team_unlocked"); } catch (e) {}
        window.location.href = "/pages/team";
      });
    }
  }

  // Initial cart fetch (for header badge)
  refreshCart();
})();
